import { LogOut, Moon, Settings2, Sun } from "lucide-react";

import NavIconBtn from "./Navbar/NavIconBtn";
import PopUpNotes from "../Panels/PopUpNotes";
import PopUpTicket from "../Panels/PopUpTicket";
import PopUpLogOut from "../Panels/PopUpLogOut";
import PopUpSettings from "../Settings/PopUpSettings";
import { useDark } from "../Universal/useNavTheme";
import { usePopup } from "../contexts/PopupContext";
import { useTheme } from "../contexts/ThemeContext";

// The five chrome actions — Ticket · Notes · Theme · Settings · Logout —
// defined ONCE (NAVBAR_REMOVAL_PLAN.md §2): the sidebar dock is their ONE
// GS home (birr dropped the lens-bar hamburger skin on sight, 2026-08-17 —
// the dock covers it). Settings and Logout have NO other entry points in
// the app — this is the door, not decoration.

const useChromeActions = () => {
  const dark = useDark();
  const { setIsPopUpOpen, setPopUpComponent } = usePopup();
  const { darkmode, setDarkmode } = useTheme();

  const openLogout = () => {
    setPopUpComponent(<PopUpLogOut />);
    setIsPopUpOpen(true);
  };

  const openSettings = () => {
    setPopUpComponent(<PopUpSettings />);
    setIsPopUpOpen(true);
  };

  return { dark, darkmode, setDarkmode, openSettings, openLogout };
};

/* ── dock skin: the sidebar's bottom row ── */
export const ChromeActionsDock = () => {
  const { dark, darkmode, setDarkmode, openSettings, openLogout } =
    useChromeActions();

  return (
    <>
      <PopUpTicket buttonNavbar={true} />
      <PopUpNotes buttonNavbar={true} />
      <NavIconBtn
        onClick={() => setDarkmode(!darkmode)}
        aria-label={dark ? "Switch to light mode" : "Switch to dark mode"}
        title={dark ? "Light Mode" : "Dark Mode"}
      >
        {dark ? (
          <Sun
            strokeWidth={1.5}
            className="h-[18px] w-[18px] text-mutedText/60 transition-colors duration-200"
          />
        ) : (
          <Moon
            strokeWidth={1.5}
            className="h-[18px] w-[18px] text-mutedText/60 transition-colors duration-200"
          />
        )}
      </NavIconBtn>
      <NavIconBtn onClick={openSettings} aria-label="Settings" title="Settings">
        <Settings2
          strokeWidth={1.5}
          className="h-[18px] w-[18px] text-mutedText/60 transition-colors duration-200"
        />
      </NavIconBtn>
      <NavIconBtn onClick={openLogout} aria-label="Log out" title="Log out" danger>
        <LogOut
          strokeWidth={1.5}
          className="h-[18px] w-[18px] text-logoutColor transition-colors duration-200"
        />
      </NavIconBtn>
    </>
  );
};

